import { createCrudApi } from './crud';

export interface LabourRate {
  id: number;
  activityCode: string;
  activityName: string;
  unit: string;
  standardRate: number;
  status: 'active' | 'inactive';
  createdAt: string;
}

export interface CreateLabourRateInput {
  activityName: string;
  unit: string;
  standardRate: number;
  status?: 'active' | 'inactive';
}

export const labourRatesApi = createCrudApi<LabourRate, CreateLabourRateInput>('labour-rates');
